import { createSelector } from 'reselect';

export const getFabricDataValuesUnfiltered = state => Object.values(state.config.fabric.fabricData)

export const getFabricUnfiltered = state => state.config.fabric.fabricData

export const getGenericFabricSet = state => state.config.fabric.setToArticles.GenericFabricSet;

export const getInStockFabricList = state => state.config.inStock.FabricList

export const getFabricData = state => state.config.fabric.fabricData;

export const getFabricSetToArticles = state => state.config.fabric.setToArticles;

export const getAttr = state => state.config.attr;


export const getSizes = state => state.config.sizes;

export const getLayout = state => state.config.layout;

export const getRender = state => state.config.render;

export const getPresets = state => state.config.presets;

export const getSkeleton = state => state.config.skeleton;

export const makeIsFabricExsists = (fabricId) => (
    createSelector(
        getFabricData,
        (fabricData) => fabricData[fabricId]
    )
)

export const getFabricDataValues = createSelector(
    getFabricUnfiltered,
    getInStockFabricList,
    getGenericFabricSet,
    (fabrics, inStock, genericSet) => {
        let result = []
        for (let key of genericSet) {
            if (inStock.hasOwnProperty(key) && inStock[key] > 0) {
                result[result.length] = fabrics[key];
            }
        }
        return result
    }
)

export const getContrastFabricDataValues = createSelector(
    getFabricUnfiltered,
    getInStockFabricList,
    getGenericFabricSet,
    (fabrics, inStock, genericSet) => {
        let result = []
        for (let key of genericSet) {
            if (inStock.hasOwnProperty(key)) {
                result[result.length] = fabrics[key];
            }
        }
        return result
    }
)

/* buttons */
export const getButtonsValues = createSelector(
    getAttr,
    (attrs) => {
        return Object.values(attrs.buttons.buttons.values);
    }
);

export const getFilteredButtonValues = createSelector(
    getButtonsValues,
    (values) => values.filter(b => b.disabled === 'false')
);

export const getButtonsInStockValues = state => state.config.inStock.ButtonList;

export const getNormalizedButtonsValues = createSelector(
    getFilteredButtonValues,
    getButtonsInStockValues,
    (enabledButtons, inStockButtons) => {
        const result = [];
        for (let value of enabledButtons) {
            let inStockEntity = inStockButtons[value.attrValue];
            if (inStockEntity && inStockEntity > 0) {
                result[result.length] = { ...value, hexColor: '#ffffff' };
            }
        };
        return result;
    }
);

export const getNormalizedButtonsMap = createSelector(
    getNormalizedButtonsValues,
    (buttonsValues) => {
        const buttonsMap = new Map();
        for (let value of buttonsValues) {
            buttonsMap.set(value.attrValue, value);
        }
        return buttonsMap;
    }
);

/* constrast types */
export const getNormalizedContrastTypeValues = createSelector(
    getAttr,
    getLayout,
    (attrs, layout) => {
        const contrastLayoutValues = layout.sections.contrast.enums.contrastType.values;
        const contrastAttrValue = attrs.fabrics;
        let contrastTypes = [];
        for (let key of contrastLayoutValues) {
            contrastTypes.push({
                ...contrastAttrValue[key],
                attrValue: key
            })
        }
        return contrastTypes;
    }
)

/* constrast types */
export const getNormalizedContrastTypes = createSelector(
    getAttr,
    getLayout,
    (attrs, layout) => {
        const contrastLayoutValues = layout.sections.contrast.enums.contrastType.values;
        const contrastAttrValue = attrs.fabrics;
        let contrastTypes = {};
        for (let key of contrastLayoutValues) {
            contrastTypes[key] = {
                ...contrastAttrValue[key],
                attrValue: key
            }
        }
        return contrastTypes;
    }
)